import { apiFetch } from './api';

const apiUrl = import.meta.env.VITE_API_URL;

export interface StartTestSessionResponse {
    sessionId?: string;
    /** Qual agente realmente atendeu — sem isto, a tela não tem como saber. */
    agenteId?: number;
    agentName?: string;
    isDefault?: boolean;
    mensagem?: string;
}

export interface SendTestMessageRequest {
    sessionId: string;
    message: string;
    agenteId?: number;
}

export interface ResetTestSessionRequest {
    sessionId: string;
    agenteId?: number;
}

export class AgentTesterService {
    /**
     * Inicia uma nova sessão de teste do agente.
     *
     * Sem `agenteId` a API cai no agente padrão da empresa — que era o único
     * comportamento possível até 2026-09-10. Passe o id sempre que a tela
     * souber qual agente está aberto, senão o teste conversa com outro.
     */
    static async startSession(agenteId?: number): Promise<StartTestSessionResponse> {
        const response = await apiFetch(`${apiUrl}/api/AgentTester/start`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ agenteId: agenteId ?? null }),
        });

        if (!response.ok) {
            throw new Error('Falha ao iniciar sessão de teste do agente');
        }

        return response.json();
    }

    /**
     * Envia uma mensagem para o agente na sessão atual.
     */
    static async sendMessage(payload: SendTestMessageRequest): Promise<any> {
        const response = await apiFetch(`${apiUrl}/api/AgentTester/send-message`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            throw new Error('Falha ao enviar mensagem para o agente');
        }

        return response.json();
    }

    /**
     * Reseta a sessão atual do agente.
     */
    static async resetSession(payload: ResetTestSessionRequest): Promise<any> {
        const response = await apiFetch(`${apiUrl}/api/AgentTester/reset`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            throw new Error('Falha ao resetar sessão do agente');
        }

        return response.json();
    }
}
